// extracted by mini-css-extract-plugin
export default {"root":"ListTabs_root__H4r3V","tab":"ListTabs_tab__MKhma","--active":"ListTabs_--active__eGnmr","--has-otc":"ListTabs_--has-otc__+TIwd"};